import React, { useReducer } from 'react';
import ModalContext from './ModalContext';
import ModalRoot from './ModalRoot';
import ModalGlobalStyles from '../ModalGlobalStyles';
var initialState = {
  isOpen: false,
  component: null,
  modalProps: {}
};
var actions = {
  OPEN_MODAL: 'OPEN_MODAL',
  REMOVE_MODAL: 'REMOVE_MODAL',
  HIDE_MODAL: 'HIDE_MODAL'
};

function reducer(state, action) {
  switch (action.type) {
    case actions.OPEN_MODAL:
      {
        var _action$payload = action.payload,
            component = _action$payload.component,
            modalProps = _action$payload.modalProps;
        return Object.assign({}, state, {
          isOpen: true,
          component: component,
          modalProps: modalProps
        });
      }

    case actions.HIDE_MODAL:
      {
        return Object.assign({}, state, {
          isOpen: false
        });
      }

    case actions.REMOVE_MODAL:
      {
        return Object.assign({}, state, {
          isOpen: false,
          component: null,
          modalProps: {}
        });
      }

    default:
      return state;
  }
}

var ModalProvider = function ModalProvider(_ref) {
  var children = _ref.children;

  var _useReducer = useReducer(reducer, initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var value = {
    isOpen: state.isOpen,
    component: state.component,
    modalProps: state.modalProps,
    showModal: function showModal(component, modalProps) {
      dispatch({
        type: actions.OPEN_MODAL,
        payload: {
          component: component,
          modalProps: modalProps
        }
      });
    },
    removeModal: function removeModal() {
      setTimeout(function () {
        dispatch({
          type: actions.REMOVE_MODAL
        });
      });
    },
    hideModal: function hideModal() {
      dispatch({
        type: actions.HIDE_MODAL
      });
    }
  };
  return /*#__PURE__*/React.createElement(ModalContext.Provider, {
    value: value
  }, /*#__PURE__*/React.createElement(ModalGlobalStyles, null), /*#__PURE__*/React.createElement(ModalRoot, null), children);
};

ModalProvider.defaultProps = {
  children: undefined
};
export default ModalProvider;